import { SupabaseClient } from '@supabase/supabase-js';

export const findRecipeIdsByTags = async (
  supabaseClient: SupabaseClient,
  selectedTagIds: number[]
): Promise<string[]> => {
  const { data: recipeTagData, error: recipeTagError } = await supabaseClient
    .from('recipe_tags')
    .select('recipe_id')
    .in('tag_id', selectedTagIds);

  if (recipeTagError) {
    throw new Error(recipeTagError.message);
  }

  return (recipeTagData || []).map((item) => item.recipe_id);
};

export const insertRecipeTags = async (
  supabaseClient: SupabaseClient,
  recipeId: string,
  tagIds: number[]
): Promise<void> => {
  if (tagIds.length === 0) {
    return;
  }

  const recipeTags = tagIds.map((tagId) => ({ recipe_id: recipeId, tag_id: tagId }));
  const { error } = await supabaseClient.from('recipe_tags').insert(recipeTags);

  if (error) {
    throw new Error(error.message);
  }
};

export const replaceRecipeTags = async (
  supabaseClient: SupabaseClient,
  recipeId: string,
  tagIds: number[]
): Promise<void> => {
  const { error: deleteError } = await supabaseClient
    .from('recipe_tags')
    .delete()
    .eq('recipe_id', recipeId);

  if (deleteError) {
    throw new Error(deleteError.message);
  }

  await insertRecipeTags(supabaseClient, recipeId, tagIds);
};
